import styled from 'styled-components'

import Icon from '~/components/icon'
import _ProductHeading from '~/components/product-heading'
import { device, color, font } from '~/styles/utils'

export const ProductHeading = styled(_ProductHeading)`
  padding: 12px 0;
  width: calc(100% - 50px);
`

export const OrderItem = styled.li`
  overflow: none;
  list-style: none;
  padding: 12px 20px;
  box-shadow: 5px 6px 30px 0 rgba(0, 0, 0, 0.15);
  margin: 0 0 12px 0;
  @media ${device('notMobile')} {
    padding: 20px 40px;
  }
  color: ${({ theme }) => theme.color.text.default};
  background-color: white;
`

export const Profile = styled.div`
  display: flex;
  padding: 0 0 8px 0;
`

export const GoggleIcon = styled(Icon)`
  font-size: 17px;
  margin: 5px 10px 0 0;
`

export const ProfileName = styled.span`
  ${font('bold')};
  margin: 0;
  font-size: 16px;
  text-transform: uppercase;
  white-space: nowrap;
  align-self: center;
  color: ${({ theme }) => theme.color.text.default};
  font-weight: bold;
`

export const HeadingLine = styled.div`
  display: flex;
  justify-content: space-between;
`

export const HeadingWrapper = styled.div`
  border-bottom: 1px solid ${color('lightGrey')};
`
